export const meta = {
  id: 'A07',
  slug: 'avancar-em-uma-formacao',
  title: 'Como avançar em uma Formação',
  description: 'Entenda etapas, componentes, bloqueios, pré-requisitos e a próxima ação de uma Formação.',
  profile: 'student',
  category: 'formacoes',
  type: 'flow',
  status: 'published',
  order: 120,
  keywords: ['formação', 'avançar', 'componente bloqueado', 'pré-requisito', 'obrigatório', 'opcional'],
  previous: 'A06',
  next: 'A09',
  related: ['A06', 'A13', 'A13.1'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Como avançar em uma Formação

Depois de abrir uma Formação, avance pelos componentes liberados conforme a estrutura definida para o programa.

## Passo a passo

<Steps>
  <Step title="Abra a Formação">
    Consulte o objetivo, seu progresso e as etapas disponíveis.
  </Step>
  <Step title="Localize o próximo componente">
    Identifique o componente disponível ou a próxima ação indicada.
  </Step>
  <Step title="Execute a atividade">
    Realize o Treinamento, atividade prática, estudo de caso, role play, aula ao vivo, Mentoria, Evidência ou checkpoint correspondente.
  </Step>
  <Step title="Registre a conclusão quando aplicável">
    Depois da conclusão, o progresso é atualizado e o próximo componente pode ser liberado.
  </Step>
</Steps>

<HelpImage alt="Detalhe de uma Formação com etapas e componentes" pendingId="A07.2" />
<HelpImage alt="Componente de Formação bloqueado por pré-requisito" pendingId="A07.3" />

## Por que um componente pode estar bloqueado

Um componente pode depender da conclusão de outro. Nesse caso, o bloqueio representa um **pré-requisito real de liberação**.

<Callout type="important">
  Componentes **obrigatórios** precisam ser concluídos conforme as regras da Formação. Componentes **opcionais** não bloqueiam a conclusão final.
</Callout>
